<template>
  <picture-input
    ref="invoiceLogoInput"
    accept="image/jpeg, image/png"
    :custom-strings="{
      drag: 'Drag your logo here or click to upload'
    }"
    :zIndex="0"
    :alertOnError="false"
    :crop="false"
    :prefill="invoiceLogoFile"
    @change="onLogoChange"
    :customStrings="{'change': 'Change Logo'}"
    :hideChangeButton="hideChangeButton"
    :style="{border: '2px solid rgba(0,0,0,0.06)'}"
  />
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import PictureInput from "vue-picture-input";

export default {
  components: {
    PictureInput
  },
  props: {
    hideChangeButton: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    ...mapActions(["fetchInvoiceLogo", "updateInvoiceLogo"]),
    onLogoChange(image) {
      this.updateInvoiceLogo(image);
    }
  },
  computed: mapGetters(["invoiceLogoFile"]),
  created() {
    this.fetchInvoiceLogo();
  }
};
</script>
